import Vue from "vue";
import Vuex from "vuex";
import main_order from './modules/main_order'
import customer from './modules/customer'
import customerLevel from './modules/customerLevel'
import authentication from './modules/authentication'
import rechargeHistory from './modules/rechargeHistory'
import paymentHistory from './modules/paymentHistory'
import orderComment from './modules/orderComment'
import orderTransaction from './modules/orderTransaction'
import payOrder from './modules/payOrder'
import withDraw from './modules/withDraw'
import deposit from './modules/deposit'
import complain from './modules/complain'
import storeManager from './modules/storeManager'
import bigPackage from './modules/bigPackage'
import feeBuy from './modules/feeBuy'
import feeWeight from './modules/feeWeight'
import feeVolume from './modules/feeVolume'
import configuration from './modules/configuration'
import staff from './modules/staff'
import roles from './modules/roles'
import notification from './modules/notification'
import historypaywallet from './modules/historypaywallet'
import changedHistories from './modules/changedHistories'
import bigPackageVn from './modules/bigPackageVn'
import commons from './modules/commons'
import report from './modules/report'
import dashboard from './modules/dashboard'
import warehouse from './modules/warehouse'
import deliverable from './modules/deliverable'
import accountant_order from './modules/accountant_order'
import accountant_cumulation from './modules/accountant_cumulation'
import accountant_cumulation_vnd from './modules/accountant_cumulation_vnd'
import ordercn from './modules/ordercn'
import payservice from './modules/payservice'
import payauthority from './modules/payAuthority'
import tuikuan from './modules/tuikuan'
import storereport from './modules/storereport'
import internalfinance from './modules/internalfinance'
import contact from './modules/contact'
import contact_care from './modules/contact_care'
import opportunity from './modules/opportunity'
import chinaStore from './modules/chinaStore'
import tranferStore from './modules/tranferStore'
import orderFlag from './modules/orderFlag'
import flag from './modules/flag'
import feeCheck from './modules/feeCheck'
import feeGuarantee from './modules/feeGuarantee'
import feeReinforce from './modules/feeReinforce'
import prices from './modules/prices'
import financeLog from './modules/financeLog'
import priceLog from './modules/priceLog'
import storeVnKennel from './modules/storeVnKennel'
import storeVnCheck from './modules/storeVnCheck'
import filters from './modules/filters'
import paymentRequest from './modules/paymentRequest'
import paymentRequestDetail from './modules/paymentRequestDetail'
import exportReceipt from './modules/exportReceipt'
import bank_message from './modules/bank_message'
import packageImage from './modules/packageImage'
import voucher from './modules/voucher'
import voucherDetail from './modules/voucherDetail'
import voucherCustomer from './modules/voucherCustomer'
import checkBigpackage from './modules/checkBigpackage'
import checkBigpackageDetail from './modules/checkBigpackageDetail'
import orderFee from './modules/orderFee'
import discountRate from './modules/discountRate'
import systemLog from './modules/systemLog'
import package_routing from './modules/package_routing'
import znsMsg from './modules/znsMsg'
import znsNoti from './modules/znsNoti'
import safeLevel from './modules/safeLevel'
import feeWeightCommission from './modules/feeWeightCommission'
import hsCode from './modules/hsCode'
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    customer,
    customerLevel,
    main_order,
    authentication,
    rechargeHistory,
    paymentHistory,
    orderComment,
    orderTransaction,
    payOrder,
    withDraw,
    deposit,
    complain,
    storeManager,
    bigPackage,
    bigPackageVn,
    feeBuy,
    feeWeight,
    configuration,
    staff,
    roles,
    notification,
    historypaywallet,
    changedHistories,
    report,
    dashboard,
    warehouse,
    deliverable,
    accountant_order,
    accountant_cumulation,
    accountant_cumulation_vnd,
    ordercn,
    feeVolume,
    payservice,
    payauthority,
    tuikuan,
    storereport,
    internalfinance,
    contact,
    contact_care,
    opportunity,
    chinaStore,
    tranferStore,
    orderFlag,
    flag,
    feeCheck,
    feeGuarantee,
    feeReinforce,
    prices,
    financeLog,
    priceLog,
    storeVnKennel,
    storeVnCheck,
    filters,
    paymentRequest,
    paymentRequestDetail,
    exportReceipt,
    bank_message,
    commons,
    packageImage,
    voucher,
    voucherDetail,
    voucherCustomer,
    checkBigpackage,
    checkBigpackageDetail,
    orderFee,
    discountRate,
    systemLog,
    package_routing,
    znsMsg,
    znsNoti,
    safeLevel,
    hsCode,
    feeWeightCommission
  },
  state: {},
  mutations: {},
  actions: {},
  strict: false,
  plugins: [createPersistedState({paths:['authentication', 'commons', 'roles'], storage: window.localStorage})]
});
